import React from 'react';

const Launch = (props: any) => (
    <svg width={16} height={16} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="currentColor"
            strokeWidth="2"
            d="M13 8.45v4.37c0 1.2-.98 2.18-2.18 2.18H3.18C1.98 15 1 14.02 1 12.82V5.18C1 3.98 1.98 3 3.18 3h4.37m2.95-2H15v4.5M15 1L8 8"></path>
    </svg>
);

export default Launch;
